import ProductionCompanies from './ProductionCompanies';

export default ProductionCompanies;
